import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { EstatusIndicador } from './estatusIndicadorCarga';
import { ServicioIndicadorCarga } from './indicador-carga.servicio';

/**
 * Componente que muestra un indicador de carga al usuario.
 */
@Component({
    //moduleId: module.id,
    selector: 'ruv-indicador-carga',
    templateUrl: 'indicador-carga.componente.html',
    styleUrls: ['indicador-carga.componente.css']
})

export class ComponenteIndicadorCarga implements OnDestroy, OnInit {

    //#region Propiedades

    /**
     * Información de despliegue y mensaje del loader.
     * @type {{esVisible: boolean, mensaje: string}}
     */
    public estatus: EstatusIndicador =
    {
        esVisible: false,
        mensaje: '',
        esFullScreen: false
    };

    //#endregion

    //#region Campos

    /**
     * Subscripción al cambio de estatus.
     */
    private subscripcionCambioEstatus: Subscription;

    //#endregion

    //#region Constructor

    /**
     * Contructor de la clase.
     * @param servicioLoader Servicio para mostrar indicadores de carga al usuario.
     */
    constructor(private servicioCargaIndicador: ServicioIndicadorCarga) { }

    //#endregion

    //#region Eventos del ciclo de vida

    /** @inheritdoc */
    ngOnInit() {
        this.subscripcionCambioEstatus = this.servicioCargaIndicador.onCambioEstatus
            .subscribe(nuevoEstatus => {
                this.estatus = nuevoEstatus;
            });
    }

    /** @inheritdoc */
    ngOnDestroy() {
        this.subscripcionCambioEstatus.unsubscribe();
    }

    //#endregion
}
